import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["isNodeExpanded", "isNodeVisible", "getMatchedLabelParts", "registerNode", "unregisterNode", "toggleNode", "isFirstNode", "activeNodeId"];
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import { useCallback, useContext, useEffect, useMemo } from "react";
import { useTranslator } from "@jutro/locale";
import { TreeViewContext } from "./TreeViewContext";
import { TreeViewDescendantContext } from "./TreeViewDescendantContext";
export var useTreeNode = function (nodeId, nodeLabel, disabled) {
  var treeViewContext = useContext(TreeViewContext),
    treeViewDescendantContext = useContext(TreeViewDescendantContext);
  if (!treeViewContext) throw new Error("Please make sure the hook is used in the TreeViewContext and TreeViewDescendantContext scope.");
  var translator = useTranslator(),
    isNodeExpanded = treeViewContext.isNodeExpanded,
    isNodeVisible = treeViewContext.isNodeVisible,
    getMatchedLabelParts = treeViewContext.getMatchedLabelParts,
    registerNode = treeViewContext.registerNode,
    unregisterNode = treeViewContext.unregisterNode,
    toggleNode = treeViewContext.toggleNode,
    isFirstNode = treeViewContext.isFirstNode,
    activeNodeId = treeViewContext.activeNodeId,
    other = _objectWithoutProperties(treeViewContext, _excluded),
    parentPath = treeViewDescendantContext.parentPath,
    path = useMemo(function () {
      var _context;
      return _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(parentPath), [nodeId]);
    }, [parentPath, nodeId]),
    expanded = isNodeExpanded(nodeId),
    visible = isNodeVisible(nodeId, path),
    labelMatches = getMatchedLabelParts(nodeId),
    translatedLabel = translator(nodeLabel);
  useEffect(function () {
    return registerNode(nodeId, translatedLabel, parentPath, disabled), function () {
      unregisterNode(nodeId);
    };
  }, [nodeId, parentPath, translatedLabel, disabled]);
  var toggle = useCallback(function () {
      toggleNode(nodeId);
    }, [toggleNode, nodeId]),
    isActiveNode = activeNodeId === nodeId,
    tabIndex = useMemo(function () {
      return isActiveNode || !activeNodeId && isFirstNode(nodeId) ? 0 : -1;
    }, [nodeId, isFirstNode, activeNodeId]);
  return _objectSpread(_objectSpread({}, other), {}, {
    translatedLabel: translatedLabel,
    expanded: expanded,
    visible: visible,
    path: path,
    toggle: toggle,
    labelMatches: labelMatches,
    activeNodeId: activeNodeId,
    tabIndex: tabIndex,
    isActiveNode: isActiveNode
  });
};